import React, { useContext } from "react";

import { AnnotatedPlan } from "types/explain";
import { enrichPlan } from "utils/explain";

const PlanContext = React.createContext<ComparablePlanType | undefined>(
  undefined,
);

const ComparePlanContext = React.createContext<ComparablePlanType | undefined>(
  undefined,
);

export type ComparablePlanType = {
  id: string;
  humanId?: string;
  label: string;
  url?: string;
  fingerprint: string;
  seenAt: number;
  plan: AnnotatedPlan;
  runtime: number | undefined;
  totCost: number | undefined;
  ioBytes: number | undefined;
  ioMs: number | undefined;
};

export type ComparablePlanSummaryType = Pick<
  ComparablePlanType,
  "id" | "fingerprint" | "label" | "runtime" | "ioMs"
>;

const WithExplainPlan = ({
  children,
  plan,
  comparePlan,
}: {
  children: React.ReactNode;
  plan?: ComparablePlanType;
  comparePlan?: ComparablePlanType;
}) => {
  const enrichedPlan = plan && {
    ...plan,
    plan: {
      ...plan.plan,
      plan: enrichPlan(plan.plan.plan),
    },
  };
  const enrichedComparePlan = comparePlan && {
    ...comparePlan,
    plan: {
      ...comparePlan.plan,
      plan: enrichPlan(comparePlan.plan.plan),
    },
  };

  return (
    <PlanContext.Provider value={enrichedPlan}>
      <ComparePlanContext.Provider value={enrichedComparePlan}>
        {children}
      </ComparePlanContext.Provider>
    </PlanContext.Provider>
  );
};

export function useCurrentPlan() {
  return useContext(PlanContext);
}

export function useCurrentComparePlan() {
  return useContext(ComparePlanContext);
}

export default WithExplainPlan;
